import React from 'react';

interface IndicatorProps {
  className?: string;
}

export const Indicator: React.FC<IndicatorProps> = ({ className = '' }) => {
  return (
    <div className={`flex items-center justify-center ${className}`} role="status" aria-label="Loading">
      <div className="relative">
        <div className="h-10 w-10 rounded-full border-2 border-deep-gray-700 border-t-primary animate-spin"></div>
      </div>
    </div>
  );
};
